export enum SeasonTypeEnum {
  IncentiveV2 = 'IncentiveV2',
  SOG = 'SOG',
  GBR = 'GBR',
  Merit = 'Merit',
  SpecialPayment = 'SpecialRecognition', // Only used as generic SP season
  SpecialPaymentCash = 'SpecialPaymentCash',
  SpecialPaymentEquity = 'SpecialPaymentEquity',
  PositionEvaluation = 'PositionEvaluation',
  ExceptionalRecognitions = 'ExceptionalRecognitions',
  Unknown = 'Unknown',
  Restructuring = 'Restructuring'
}
